module.exports = __webpack_public_path__ + "img/1508.e21f6d3f.jpg";